<div [ngStyle]="containerStyle" style="position:absolute; z-index:50">
    <div [ngStyle]="gameOverStyle">GAME OVER</div><br><br>
    <div [ngStyle]="scoreStyle" [innerHTML]="'Score: ' + this.score.score"></div><br><br>
    <div [ngStyle]="restartStyle" [innerHTML]="isMobile ? 'Press JUMP to Restart' : 'Press SPACE to Restart'"></div>
</div>
